import styles from "./index.module.scss";
import cn from "classnames";

const CalcFormItem = ({
  label,
  htmlFor,
  required,
  className,
  children,
  variant = "gray",
  labelSize = "medium",
}) => {
  return (
    <div className={cn(styles.wrapper, styles[variant], className)}>
      {label && (
        <label
          className={cn(styles.label, styles[labelSize])}
          htmlFor={htmlFor}
        >
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      {children}
    </div>
  );
};

export default CalcFormItem;
